import styled from 'styled-components';

import Textarea from 'web-components/Textarea';

export const Card = styled.div`
  width: 100%;
  border: 1px solid #F0F0F0;
  box-shadow: 0px 3px 6px 0px #00000029;

  background: #fff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;

  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 16px;
    border-bottom: 1px solid #F0F0F0;

    h5 {
      color: #717171;
      font-weight: 700;
      font-size: 18px;
      line-height: 100%;
      margin: 0;
      padding: 5px 0;
    }
  }

  textarea::placeholder {
    color: #CCCCCC;
    font-weight: 400;
    font-size: 18px;
  }

  textarea {
    color: #717171;
    font-weight: 400;
    font-size: 18px;
    padding: 18px;
    flex: 1 1 100%;
    overscroll-behavior: contain;
  }
`;

export const NoteDisplay = styled.div`
  .note-content,
  .empty-note {
    padding: 18px;
    white-space: break-spaces;
  }

  .note-content {
    height: 120px;
    padding-bottom: 10px;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
  }

  .note-content,
  .empty-note {
    font-weight: 400;
    font-size: 18px;
  }

  .empty-note {
    color: #CCCCCC;
  }
`;

export const TextBox = styled(Textarea).attrs({
  minRows: 5,
})`
  width: 100%;
  border: none;
`;
